// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:1280px){.widgets__grid{gap:28px}}.widgets__two-cols{display:grid;grid-template-columns:1fr 1fr;grid-column-gap:28px}.widgets__two-cols--full{grid-column:span 2}.widgets .widgets__first-time-hint{margin-bottom:28px}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}", ""]);
// Exports
module.exports = exports;
